import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getProfileInfo } from "../../axios/axiosFunctions";
import { Box, Button, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DisplayProfileForm from "../../components/DisplayProfileForm";
import MyAssessmentsProfile from "../../components/MyAssessmentsProfile";

const ProfileAdmin = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState();

  useEffect(() => {
    const callProfileInfo = async () => {
      const resp = await getProfileInfo(userId);
      if (resp) {
        setUserInfo(resp.user);
      }
    };
    callProfileInfo();
  }, []);

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <>
      <Box display="flex" alignItems="center" gap={2} sx={{ mb: 2 }}>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={handleBack}
          size="small"
        >
          Back
        </Button>
        <Typography variant="h3" fontWeight={500} color="secondary">
          Profile
        </Typography>
      </Box>
      <DisplayProfileForm
        userInfo={userInfo}
        userId={userId}
        setUserInfo={setUserInfo}
      />
      <MyAssessmentsProfile
        userId={userId}
        userName={`${userInfo?.firstName || ""} ${userInfo?.lastName || ""}`.trim()}
      />
    </>
  );
};

export default ProfileAdmin;
